module.exports = __webpack_public_path__ + "img/dienteTabla.d202f908.svg";